export default __webpack_public_path__ + "static/media/drip.1505b5cf.png";